<template>
  <div class="container">
    <el-button
      type="text"
      class="btn-wrapper"
      @click="emitServerPointDialog"
    >
      <el-badge class="mark" :value="serverListFlatten.length || 0">
        <i class="el-icon-ali-jiedian el-icon"></i>
        节点
      </el-badge>
    </el-button>
    <el-dialog
      title="节点统计"
      :visible.sync="serverPointDialogShow"
      width="60%"
    >
      <el-table :data="serverListFlatten" style="width: 100%">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="#"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="server_uuid"
          label="节点ID"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="columnProp"
          label="状态"
        >
          <template slot-scope="scope">
            <el-tag
              type="primary"
              v-if="!scope.row.gpu_index && scope.row.server_status === '1'"
            >空闲</el-tag
            >
            <el-tag
              type="primary"
              v-if="scope.row.gpu_index && scope.row.server_status === '1'"
            ><i class="el-icon-loading"></i>运行中
            </el-tag>
            <el-tag type="danger" v-if="scope.row.server_status !== '1'"
            >离线</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="GPU运行地址"
        >
          <template slot-scope="scope">
            {{ scope.row.gpu_index || "空闲" }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="eatery_name"
          label="食堂"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="canteen_name"
          label="餐厅"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.gpu_index"
              type="text"
              @click="viewUnderCanteen(scope.row)"
            >定位任务</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiGetServerPointList} from '@/api';

export default {
  name: "serverPoint",
  components: {},
  data() {
    return {
      serverPointDialogShow: false,
      serverPointList: []
    };
  },
  mounted() {
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    ...mapActions([]),
    async getServerPointList() {
      try {
        let res = await apiGetServerPointList();
        this.serverPointList = res.server_list;
      } catch (e) {
        console.log(e);
        this.$message.error("节点数据获取失败");
      }
    },
    async emitServerPointDialog(show) {
      try {
        this.getServerPointList();
        this.serverPointDialogShow = true;
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    ...mapGetters([]),
    serverListFlatten() {
      let res = this.serverPointList.map(a => {
        if (a.server_status === "1") {
          if (a.gpu_info_list.length > 0) {
            a.gpu_info_list.forEach(b => {
              this.$set(b, "server_uuid", a.server_uuid);
              this.$set(b, "server_status", a.server_status);
            });
            return a.gpu_info_list;
          } else {
            return a;
          }
        } else {
          return a;
        }
      });
      return this.$_.flatten(res);
    }
  },
  watch: {}
};
</script>
<style></style>
